import { userProfileReducer } from "./userProfileReducer";
import { alertReducer } from "./alertReducer";
import { superSummaryReducer } from "./superSummaryReducer";

const userProfile = userProfileReducer;
const alert = alertReducer;
const superSummary = superSummaryReducer;

export { userProfile, alert, superSummary };
